import { render, staticRenderFns } from "./deleteConfig.vue?vue&type=template&id=d7282880&scoped=true"
import script from "./deleteConfig.vue?vue&type=script&lang=js"
export * from "./deleteConfig.vue?vue&type=script&lang=js"
import style0 from "./deleteConfig.vue?vue&type=style&index=0&id=d7282880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7282880",
  null
  
)

export default component.exports